import throttle from 'lodash.throttle'
import { showHide } from './utils/showHide'

const rootEl = document.documentElement

document.addEventListener('DOMContentLoaded', () => {
  const $menuToggle = document.getElementById('primary-menu-toggle')
  if ($menuToggle !== null) {
    $menuToggle.addEventListener('click', () => {
      // Get the target from the "data-target" attribute
      const target = $menuToggle.dataset.target
      const $target = document.getElementById(target)
      const toggleExpanded = ($menuToggle.getAttribute('aria-expanded') === 'true') ? false : true
      $menuToggle.classList.toggle('is-active')
      $menuToggle.setAttribute('aria-expanded', toggleExpanded)
      document.body.classList.toggle('menu-is-active')
      $target.classList.toggle('is-active')
      rootEl.classList.toggle('is-clipped')
    })
  }
  const $submenuToggle = document.querySelectorAll('.toggle-subnavigation')
  $submenuToggle.forEach(element => {
    element.addEventListener('click', (event) => {
      toggleNav(element)
    })
  })
})

function toggleNav (element) {
  const expanded = element.getAttribute('aria-expanded')
  if (expanded === 'false') {
    element.setAttribute('aria-expanded', true)
  } else {
    element.setAttribute('aria-expanded', false)
  }
  const parent = element.parentElement
  parent.classList.toggle('show-subnav')
}

window.onresize = throttle(() => {
  const ww = window.outerWidth
  const $menuToggle = document.getElementById('primary-menu-toggle')
  if ($menuToggle !== null && ww > 1024) {
    const target = $menuToggle.dataset.target
    const $target = document.getElementById(target)
    $menuToggle.classList.remove('is-active')
    $target.classList.remove('is-active')
  }
}, 250)

/* Search */

let searchOpen = false
const searchToggle = document.getElementById('search-trigger')
const searchEl = document.getElementById('primary-searchform')
const searchInput = document.getElementById('search-input')

const closeSearch = () => {
  searchToggle.setAttribute('aria-expanded', false)
  searchEl.setAttribute('aria-hidden', true)
  showHide(searchEl)
  searchToggle.focus()
  searchOpen = false
}

if (searchToggle !== null) {
  searchToggle.addEventListener('click', function () {
    if (searchOpen === true) {
      closeSearch()
    } else {
      searchToggle.setAttribute('aria-expanded', true)
      searchEl.setAttribute('aria-hidden', false)
      showHide(searchEl)
      searchInput.focus()
      searchOpen = true
    }
  })
}

const escapeMenus = (evt) => {
  evt = evt || window.event
  let isEscape = false
  if ('key' in evt) {
    isEscape = (evt.key === 'Escape' || evt.key === 'Esc')
  } else {
    isEscape = (evt.keyCode === 27)
  }
  if (isEscape) {
    if (searchOpen === true) {
      closeSearch()
    }
  }
}
window.addEventListener('keydown', escapeMenus)

const submitSearch = (evt) => {
  evt = evt || window.event
  let isSubmit = false
  if ('key' in evt) {
    isSubmit = (evt.key === 'Return' || evt.key === 'Enter' || evt.keyCode === 13)
  }
  if (isSubmit) {
    if (searchOpen === true) {
      searchEl.submit()
    }
  }
}
window.addEventListener('keydown', submitSearch)
